module.exports = __webpack_public_path__ + "img/DefaultImage.d448916d.svg";